export default __webpack_public_path__ + "static/fagure6-12489d47fd1d044f10b05c31d77c0412.mp4";